export default function Footer() {
    return (
      <footer className="footer">
        <div className="barberfy">
          <div className="featured-footer">
            <img src="/images/logomujica_negro.svg" alt="Logo barberfy" />
            <p>X</p>
            <img src="/images/logobarberfynegro.svg" alt="Logo barberfy" />
          </div>
          <p>Creado con la tecnología de  <a href="https://barberfy.com" target="_blank" rel="noreferrer">barberfy</a></p>
        </div>
        <div className="politicas-footer">
          <a href="/politica-de-privacidad" target="_blank" rel="noreferrer">Política de privacidad</a>
          <a href="/condiciones-del-sistema-de-citas" target="_blank" rel="noreferrer">Condiciones del sistema de citas</a>
          <a href="/politica-de-servicio" target="_blank" rel="noreferrer">Política de servicio</a>
        </div>
        <p>&copy; {new Date().getFullYear()} Barber Mujica. Todos los derechos reservados.</p>
      </footer>
    );
  }
  